import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookieBase64 } from "../../../../utils/utils";

const ClickCapturePageC9RecieveRoute: React.FC = () => {
  const navigate = useNavigate();
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  useEffect(() => {
    try {
      const cookieData = JSON.parse(getCookieBase64("c9li"));
      const {
        venue_id: venueIdFromCookie,
        orig_query: origQueryFromCookie,
        venue_sublocation: venueSublocationFromCookie,
      } = cookieData;

      // Clean current URL query string (remove leading '?' if it exists)
      const currentQueryClean = window.location.search?.startsWith("?")
        ? window.location.search.substring(1)
        : window.location.search || ""; // Fallback to empty string if search is null/undefined

      // Clean original query from cookie (remove leading '?' if it exists)
      const origQueryClean = origQueryFromCookie?.startsWith("?")
        ? origQueryFromCookie.substring(1)
        : origQueryFromCookie || ""; // Fallback to empty string

      let queryParts = [];
      if (origQueryClean) {
        queryParts.push(origQueryClean);
      }
      if (currentQueryClean) {
        queryParts.push(currentQueryClean);
      }

      const combinedQueryString = queryParts.join("&");

      let pathSegment = venueIdFromCookie;
      if (
        venueSublocationFromCookie !== undefined &&
        venueSublocationFromCookie.toLowerCase() !== "hotspot"
      ) {
        pathSegment = `${venueIdFromCookie}.${venueSublocationFromCookie}`;
      }

      const baseRedirectPath = isLocalhost
        ? `/retail/${pathSegment}/c9_login`
        : `/${pathSegment}/c9_login`;

      const finalRedirectPath = combinedQueryString
        ? `${baseRedirectPath}?${combinedQueryString}`
        : baseRedirectPath;

      navigate(finalRedirectPath);
    } catch (err: any) {
      console.log("error in c9 recieve route");
      console.log(err);
      // For external redirects, window.location.href is appropriate.
      window.location.href = "https://www.boingo.com";
    }
  }, [navigate, isLocalhost]);

  // This component's main purpose is to redirect, so rendering UI is secondary.
  // Returning null is acceptable as the redirect will happen before meaningful render.
  return null;
};

export default ClickCapturePageC9RecieveRoute;
